import React, { Component } from 'react';

import './Markers.css';



class Markers extends Component {


    constructor(props) {

        super(props);       
        
    }

    shouldComponentUpdate(nextProps, nextState)
    {
        /* pas sur que ce soit utile */

        if( nextProps.markers )   return true;
        else                      return false;
    }

    render() {

        const { markers } = this.props;

        const CUI = window.g_CONFIG_UI;

        /* markers des bases docs */

        let contenus = [];
        let delay = 0;

        for(let i=0;i<markers.length;i++) // if markers exist
        {
            const k = "marker"+i;   // key
            /* texte */
            const cltxt = "basedoc_marker_text text_" + markers[i].cfg.f;
            const txcolor = CUI.colors_txt_marker[ markers[i].cfg.ct ];
            const bktxcolor = CUI.colors_txt_bkg_marker[ markers[i].cfg.bktx ];
            /* icon */
            const bkcolor = CUI.colors_bkg_marker[ markers[i].cfg.c ];
            const clicon = "basedoc_marker_icon basedoc_marker_icon_"+markers[i].type;
            const py = markers[i].cfg.y;
            let px = markers[i].cfg.x;

            let display='block';

            if(markers[i].cfg.asservi){ // asservi par un inteactif dragVideo

                //console.log("### positionTime", this.props.positionTime );
                if(this.props.positionTime)
                {
                    px = markers[i].cfg.x - this.props.positionTime * 100 * markers[i].cfg.dx ;
                }else
                    display='none'; // on ne les fait apparaitre que lorsque l'info de temps du dragVideo est arrivée
            }
            contenus.push(  <div key={ k }  style={{ top: py+"%", left: px+"%", animationDelay: delay+'s', display: display }} className="basedoc_marker" onClick={ markers[i].action }>
                                <div style={{ transform: 'rotate('+markers[i].cfg.r+'deg)', backgroundColor: bkcolor }} className="basedoc_marker_bkg">                                
                            </div>
                            <div className={ clicon } style={{ animationDelay: delay+'s' }}></div> 
                            <div className={ cltxt } style={{ color: txcolor, backgroundColor: bktxcolor }}>
                                {markers[i].t.map((item, key) => {
                                    return <span key={key}>{item}<br/></span> /* pour ajouter des <br/> */
                                })
                            }</div>
                        </div> );
            delay+=1;
        }
        
        return <div className='Markers' >
                { contenus }
            </div>
    } 
  
}

//----------------------------------------------------------------------------

export default Markers;



// WEBPACK FOOTER //
// ./src/Markers.js